import { UiDatePicker } from '@/components/ui/UiDatePicker';
import type { FormFieldDto } from '../../form.types';

interface FormFieldDateProps {
    field: FormFieldDto;
}

/** A date field with the design's calendar; it submits the ISO day like a native date input. */
export function FormFieldDate({ field }: FormFieldDateProps) {
    const title = field.validation?.find((v) => v.type === 'pattern')?.message;
    const minDate = field.validation?.find((v) => v.type === 'minDate')?.value;
    const maxDate = field.validation?.find((v) => v.type === 'maxDate')?.value;
    const min = field.validation?.find((v) => v.type === 'min')?.value;
    const max = field.validation?.find((v) => v.type === 'max')?.value;

    return (
        <UiDatePicker
            name={field.name}
            label={field.label}
            required={field.required}
            placeholder={field.options?.placeholder}
            defaultValue={field.options?.defaultValue}
            title={title}
            min={min || minDate}
            max={max || maxDate}
        />
    );
}
